import type { CamerasSort } from '@/types'

export interface CamerasListFilters {
  page: number
  search?: string
  group?: string
  ingestionType?: 'http' | 'ftp'
  onlineStatus?: 'online' | 'offline' | 'unknown'
  batteryLow?: boolean
  /** #277 — the signed-in user's order; sent as `ordering`. */
  ordering?: CamerasSort
}

/** The query parameters of `GET /cameras/` for the Cameras page: filters as before (#034,
 *  #096) plus the order (#277). One place, so the page, its restore-on-return fetch and the
 *  API client cannot drift apart. */
export function buildCamerasListParams(f: CamerasListFilters): Record<string, string | number> {
  const params: Record<string, string | number> = { page: f.page }
  if (f.search) params.search = f.search
  if (f.group && f.group !== 'all') params.group = f.group
  if (f.ingestionType) params.ingestion_type = f.ingestionType
  if (f.onlineStatus) params.online_status = f.onlineStatus
  if (f.batteryLow) params.battery_low = 'true'
  if (f.ordering) params.ordering = f.ordering
  return params
}
